<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
        <div class="doctor_info">
          <div class="t_box">
            <div class="t_title">
              <h2>의사정보</h2>
            </div>
            <div class="di_imgWrap">
              <img
                :src="
                  'https://api.thanq.kr' +
                    GET_RESERVATION_ITEM_INFO.doctorPhotoUrl
                "
              />
            </div>
            <div class="di_name t_content">
              <div class="t_img">
                <img src="@/assets/images/thanq_logo.png" />
              </div>
              <h2 v-text="GET_RESERVATION_ITEM_INFO.doctorName"></h2>
            </div>
          </div>
        </div>
        <div class="text_wrap centerCase">
          <p>원하시는 예약일을 선택해 주세요.</p>
        </div>
        <div class="datepicker-trigger">
          <input
            type="text"
            id="datepicker-trigger"
            placeholder="Select dates"
            :value="formatDates(calendar.default.dateOne)"
          />
          <AirbnbStyleDatepicker
            :trigger-element-id="'datepicker-trigger'"
            :mode="'single'"
            :date-one="calendar.default.dateOne"
            :disabled-dates="calendar.default.totalDimm"
            :monthsToShow="1"
            :inline="true"
            :widthSet="calendar.additional.width"
            :customized-dates="[
              { cssClass: 'normal', dates: ['2020-04-20', '2020-04-21'] },
              { cssClass: 'range', dates: ['2020-04-24', '2020-03-25'] }
            ]"
            :showShortcutsMenuTrigger="false"
            @date-one-selected="
              val => {
                calendar.default.dateOne = val;
                this.setPreviosButton();
                this.getDayInfo(val);
                this.getAgoDayInfo();
                this.makeTimeTable(val);
              }
            "
            @next-month="
              val => {
                this.getMonthInfo(val, 'next');
              }
            "
            @previous-month="
              val => {
                this.getMonthInfo(val, 'prev');
              }
            "
          />
        </div>
        <div class="optionDisplay">
          <div class="item">
            <span class="square"></span>
            <p>선택한 날짜</p>
          </div>
          <div class="item">
            <span class="square enabled"></span>
            <p>예약 가능한 날짜</p>
          </div>
        </div>
        <div class="timeStampWrap" v-if="calendar.additional.stampWrapShowing">
          <div class="halfBox">
            <div class="t_box">
              <div class="t_title">
                <h2>이전예약 날짜</h2>
              </div>
              <div class="t_content half">
                <h2 class="date">{{ notificationAgoDate }}</h2>
              </div>
            </div>
            <div class="t_box">
              <div class="t_title">
                <h2>선택한 날짜</h2>
              </div>
              <div class="t_content half">
                <h2 class="date" v-if="notificationDate !== ''">
                  {{ notificationDate }}
                </h2>
              </div>
            </div>
          </div>
          <div class="timeStamp">
            <h6>오전</h6>
            <ul class="morningStamp">
              <li
                class="stampItemMorning"
                @click="selectDate(m, 0)"
                v-for="(timeStampMorning, m) in timeTableMorning"
                :key="m + 'M'"
              >
                {{ timeStampMorning }}
              </li>
            </ul>
            <h6>오후</h6>
            <ul class="afterStamp">
              <li
                class="stampItemAfter"
                @click="selectDate(a, 1)"
                v-for="(timeStampAfter, a) in timeTableAfternoon"
                :key="a + 'A'"
              >
                {{ timeStampAfter }}
              </li>
            </ul>
          </div>
          <div class="t_box pb-0" v-if="reservationDate">
            <div class="t_title">
              <h2>최종예약일시</h2>
            </div>
            <div class="t_content dot">
              <h2 class="date">{{ reservationDate }}</h2>
              <h2 class="dateTime">{{ officeHour }}</h2>
            </div>
          </div>
          <div class="textareaWrap">
            <textarea
              placeholder="요청사항을 입력해주세요."
              v-model="reservationWord"
            ></textarea>
          </div>
          <h4 class="notification">원하는 일정이 없으면 진료시간 내에</h4>
          <h4 class="notification plus">전화(1522-8775)를 하시거나</h4>
          <h4 class="notification plus">
            앱에서
            <router-link to="/telReservation_step1"
              ><b>전화예약상담</b>을</router-link
            >
            신청하세요.
          </h4>
        </div>
        <div class="timeStampWrap" v-else>
          <h4 class="notification top">
            <b
              >{{ calendar.default.currentMonth }}월 예약가능한 진료일정이
              없습니다.
            </b>
          </h4>
          <h4 class="notification plus less">
            원하는 일정이 있으시면 진료시간 내에
          </h4>
          <h4 class="notification plus less">전화(1522-8775)를 하시거나</h4>
          <h4 class="notification plus less">
            앱에서
            <router-link to="/telReservation_step1"
              ><b>전화예약상담</b>을</router-link
            >
            신청하세요.
          </h4>
        </div>
        <div
          class="btnWrap visible"
          v-if="calendar.additional.stampWrapShowing"
        >
          <button type="button" @click="nextDone()">확인</button>
        </div>
        <div class="btnWrap visible" v-else>
          <button type="button" @click="goTelResv()">확인</button>
        </div>
      </div>
    </div>
    <add-popup v-if="checkPopup" :popupSet="popupSet" />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import format from 'date-fns/format'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
// import { Dert } from '@/assets/js/thanQAlert'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single',
        closeType: 'close'
      },
      transDate: {
        headerName: '예약변경',
        prevUrl: '/reservation/reservationConfirm'
      },
      calendar: {
        default: {
          dateFormat: 'D MMM',
          dateOne: '',
          nextMonth: '',
          previousMonth: '',
          currentYear: '',
          currentMonth: '',
          currentDay: '',
          monthName: '',
          today: ''
        },
        additional: {
          width: '',
          medicalMonthDate: [],
          nearMedicalDate: [],
          nearStatus: false,
          reservationAble: false,
          stampWrapShowing: false
        }
      },
      notificationAgoDate: '',
      timeTable: [],
      timeTableMorning: [],
      timeTableAfternoon: [],
      ableTime: [],
      inactivityIndex: [],
      inactivityIndexMorning: [],
      inactivityIndexAfternoon: [],
      reservationWord: '',
      reservationTime: '',
      reservationDate: '',
      notificationDate: '',
      doctorCode: '',
      dataFlag: '',
      officeHour: '',
      realTime: '',
      reservatedTimeUnit: ''
    }
  },
  created () {
    this.protection()
  },
  mounted () {},
  computed: {
    ...mapGetters([
      'GET_CALENDAR_LIST',
      'GET_RESERVATION_ITEM_INFO',
      'GET_REBOOKINGSET',
      'GET_MEDICAL_MONTH_DATE',
      'GET_RESERVATION_RESULT'
    ]),
    ...mapState(['checkPopup'])
  },
  filters: {
    // 진료시간 09:00 -> 09:00 ~ 09:59로 보여주는 메소드
    formatTimeTable: function (value, time, endTime) {
      value = value.toString()
      let valueLastFront
      let valueLastBack
      let valueBackNumberFormat
      const firstArray = []
      const lastArray = []
      if (Number(value.slice(2, 4)) === 0) {
        valueBackNumberFormat = Number(value.slice(2, 4)) + Number(time)
      } else {
        valueBackNumberFormat = Number(value.slice(2, 4)) + Number(time) - 1
      }
      console.log('목숨줄', valueBackNumberFormat)
      if (valueBackNumberFormat >= 60) {
        if (value.slice(0, 2).length === 2) {
          valueLastFront = String(Number(value.slice(0, 2)) + 1)
        } else {
          valueLastFront = '0' + String(Number(value.slice(0, 2)) + 1)
        }
        if (String(valueBackNumberFormat - 60).length < 2) {
          valueLastBack = '0' + String(valueBackNumberFormat - 60)
        } else {
          valueLastBack = String(valueBackNumberFormat - 60)
        }
      } else {
        valueLastFront = value.slice(0, 2)
        valueLastBack = valueBackNumberFormat
      }
      const valueFirstFront = value.slice(0, 2)
      const valueFirstBack = value.slice(2, 4)
      firstArray.push(valueFirstFront)
      firstArray.push(valueFirstBack)
      const mutatedValue = firstArray.join(':')
      console.log('mutatedValue1', mutatedValue)
      lastArray.push(valueLastFront)
      if (valueLastFront + valueLastBack > endTime) {
        console.log('삐뽀삐뽀')
        lastArray.push(endTime.substr(2, 4))
        console.log('LasyArrr', lastArray)
      } else {
        lastArray.push(valueLastBack)
      }
      const mutatedValue2 = lastArray.join(':')
      console.log('mutatedValue2', mutatedValue2)
      const lazarus = String(mutatedValue) + ' ~ ' + String(mutatedValue2)
      console.log('lazarus', lazarus)
      return lazarus
    }
  },
  methods: {
    ...mapMutations(['SET_POPUP']),
    ...mapActions([
      'FETCH_CALENDAR_LIST',
      'UPDATE_RESERVATION_LIST',
      'FETCH_MEDICAL_DATE'
    ]),
    goTelResv () {
      const material = '진료일정이 없습니다. 전화예약상담을 신청하시겠습니까?'
      this.SET_POPUP(true)
      this.popupSet.content = material
      this.popupSet.count = 'double'
      this.popupSet.nextLink = '/telReservation_step1'
      this.popupSet.cancelBtnText = '아니오'
      this.popupSet.confirmBtnText = '예'
    },
    protection () {
      if (this.GET_REBOOKINGSET.doctorCode === '') {
        this.SET_POPUP(true)
        this.popupSet.count = 'another'
        this.popupSet.content = '예약 변경이 취소되었습니다.'
        this.popupSet.closeType = 'action'
        this.popupSet.closeLink = '/reservation/reservationConfirm'
        this.popupSet.nextLink = '/reservation/reservationConfirm'
      } else {
        this.setRequestData()
        this.orderFunction()
        this.setCalendarVisual()
      }
    },
    setRequestData () {
      if (
        this.GET_RESERVATION_ITEM_INFO.daySet === undefined &&
        this.GET_REBOOKINGSET.doctorCode === undefined
      ) {
        this.SET_POPUP(true)
        this.popupSet.count = 'another'
        this.popupSet.content = '예약 변경이 취소되었습니다.'
        this.popupSet.closeType = 'action'
        this.popupSet.closeLink = '/reservation/reservationConfirm'
        this.popupSet.nextLink = '/reservation/reservationConfirm'
        return false
      }
      if (this.GET_RESERVATION_ITEM_INFO.doctorCode !== undefined) {
        this.doctorCode = this.GET_RESERVATION_ITEM_INFO.doctorCode
      }
      if (this.GET_REBOOKINGSET.doctorCode !== undefined) {
        this.doctorCode = this.GET_REBOOKINGSET.doctorCode
      }
    },
    async orderFunction () {
      await this.getMedicalDate(this.doctorCode, 'current')
      this.dateSet()
    },
    async getMedicalDate (doctorCode, direction) {
      const date = new Date()
      const getYear = date.getFullYear()
      const getMonth = date.getMonth()
      let year
      let month
      if (direction === 'next') {
        if (getMonth !== 11) {
          month = date.getMonth() + 2
          year = getYear
        } else {
          month = 1
          year = getYear + 1
        }
        this.calendar.additional.nearStatus = true
      } else {
        month = date.getMonth() + 1
        year = getYear
        this.calendar.additional.nearStatus = false
      }
      const medicalMonthDate = []
      try {
        const requestData = {
          year: year,
          month: month,
          doctorCode: doctorCode
        }
        await this.FETCH_MEDICAL_DATE(requestData).then(() => {
          if (this.GET_MEDICAL_MONTH_DATE !== undefined) {
            this.calendar.additional.reservationAble = true
            if (direction !== 'current') {
              for (let i = 0; i < this.GET_MEDICAL_MONTH_DATE.length; i++) {
                const parts = this.GET_MEDICAL_MONTH_DATE[i].replace(/-/g, '')
                const partsLimit = this.calendar.default.limitDay.replace(
                  /-/g,
                  ''
                )
                if (Number(parts) <= Number(partsLimit)) {
                  medicalMonthDate.push(this.GET_MEDICAL_MONTH_DATE[i])
                }
              }
            } else {
              for (let i = 0; i < this.GET_MEDICAL_MONTH_DATE.length; i++) {
                medicalMonthDate.push(this.GET_MEDICAL_MONTH_DATE[i])
              }
            }
          } else {
            this.calendar.additional.reservationAble = false
          }
        })
      } catch (error) {
        console.log('error :', error)
        console.log('예약 가능한 날짜 불러오는 api에서 에러발생')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
      this.calendar.additional.medicalMonthDate = medicalMonthDate
    },
    async getMonthList (year, month, day) {
      try {
        const requestData = {
          year: year,
          month: month,
          doctorCode: this.doctorCode,
          day: day
        }
        await this.FETCH_CALENDAR_LIST(requestData).then(() =>
          this.carryData()
        )
      } catch (error) {
        this.initializeTable()
        console.log('error :', error)
        console.log('예약시간조회 api에서 에러발생')
        if (error.status !== 401) {
          if (error.data.response.message !== 'not found data') {
            this.SET_POPUP(true)
            this.popupSet.content = errorParser.parse(error)
          } else {
            console.log('not found Data 오류입니다.')
          }
        } else {
          await this.$router.push('/login')
        }
      } finally {
        this.vidos()
      }
    },
    makeTimeTable (date) {
      const material = date.split('-')
      this.initializeTable()
      this.getMonthList(
        Number(material[0]),
        Number(material[1]),
        Number(material[2])
      )
    },
    vidos () {
      if (this.calendar.additional.stampWrapShowing) {
        document.querySelector('.morningStamp').classList.add('vidos')
      }
    },
    // 예약시간 클릭시 마킹
    selectDate (id, orderNumber) {
      let orderValue
      let findItem
      let dateTime
      let concatData
      const date = this.calendar.default.dateOne
      if (orderNumber === 0) {
        orderValue = id
        findItem = document.querySelector('.morningStamp').childNodes[
          orderValue
        ]
        dateTime = findItem.textContent.trim().substr(0, 5)
        concatData = date + 'T' + dateTime + ':00'
        console.log('합산 데이터', concatData)
        if (
          document
            .querySelector('.stampItemMorning')
            .parentNode.childNodes[orderValue].classList.contains(
              'disabledItem'
            )
        ) {
          this.SET_POPUP(true)
          this.popupSet.content = '예약할 수 없는 날입니다.'
        } else if (this.dataFlag === orderValue) {
          if (
            document
              .querySelector('.stampItemMorning')
              .parentNode.childNodes[orderValue].classList.contains('selected')
          ) {
            document
              .querySelector('.stampItemMorning')
              .parentNode.childNodes[orderValue].classList.remove('selected')
            this.reservationTime = ''
            this.dataFlag = ''
            this.reservationDate = ''
            this.officeHour = ''
          }
          if (document.querySelector('.selected')) {
            document.querySelector('.selected').classList.remove('selected')
          }
        } else {
          if (document.querySelector('.selected')) {
            document.querySelector('.selected').classList.remove('selected')
          }
          findItem.classList.add('selected')
          this.reservationTime = concatData
          this.dataFlag = orderValue
          const filterYear = date.replace(/-/gi, '.')
          const month = this.calendar.default.monthName + '요일'
          const mutatedDate = filterYear + ' ' + month
          this.reservationDate = mutatedDate
          this.officeHour = findItem.textContent
          this.reservatedTimeUnit = this.GET_CALENDAR_LIST.medicalDate[
            id
          ].timeUnit
        }
      } else if (orderNumber === 1) {
        orderValue = id
        findItem = document.querySelector('.afterStamp').childNodes[orderValue]
        dateTime = findItem.textContent.trim().substr(0, 5)
        concatData = date + 'T' + dateTime + ':00'
        if (
          document
            .querySelector('.stampItemAfter')
            .parentNode.childNodes[orderValue].classList.contains(
              'disabledItem'
            )
        ) {
          this.SET_POPUP(true)
          this.popupSet.content = '예약할 수 없는 날입니다.'
        } else if (this.dataFlag === orderValue) {
          if (
            document
              .querySelector('.stampItemAfter')
              .parentNode.childNodes[orderValue].classList.contains('selected')
          ) {
            document
              .querySelector('.stampItemAfter')
              .parentNode.childNodes[orderValue].classList.remove('selected')
            this.reservationTime = ''
            this.dataFlag = ''
            this.reservationDate = ''
            this.officeHour = ''
          }
        } else {
          if (document.querySelector('.selected')) {
            document.querySelector('.selected').classList.remove('selected')
          }
          findItem.classList.add('selected')
          this.reservationTime = concatData
          this.dataFlag = orderValue
          const filterYear = date.replace(/-/gi, '.')
          const month = this.calendar.default.monthName + '요일'
          const mutatedDate = filterYear + ' ' + month
          this.reservationDate = mutatedDate
          this.officeHour = findItem.textContent
          this.reservatedTimeUnit = this.GET_CALENDAR_LIST.medicalDate[
            id
          ].timeUnit
        }
      }
    },
    // [요일셋팅 관련함수]
    /* Date 함수 포맷 설정 */
    formatDates (dateOne) {
      let formattedDates = ''
      if (dateOne) {
        formattedDates = format(dateOne, this.calendar.default.dateFormat)
      }
      return formattedDates
    },
    // 초기 Date 값 설정하기
    dateSet () {
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const nextMonth = date.getMonth() + 2
      const day = date.getDate()
      const hour = date.getHours()
      const minute = date.getMinutes()
      /* another 재료 */
      const anotherDate = new Date()
      anotherDate.setDate(anotherDate.getDate() + 30)
      const anotherYear = anotherDate.getFullYear()
      const anotherMonth = anotherDate.getMonth() + 1
      const anotherDay = anotherDate.getDate()
      // 현재 시간 구하는 로직
      const timeNow = hour * 60 + minute
      this.realTime = timeNow
      const wholeDateArray = []
      const currentFullDaysLength = new Date(year, month, 0).getDate()
      const nextFullDaysLength = new Date(year, nextMonth, 0).getDate()
      let monthValue
      let nextMonthValue
      let anotherMonthValue
      let transDate
      let limitDay
      let today
      if (String(month).length < 2) {
        monthValue = String(year) + '-0' + String(month)
        if (month !== 9) {
          nextMonthValue = String(year) + '-0' + String(nextMonth)
        } else {
          nextMonthValue = String(year) + '-' + String(nextMonth)
        }
      } else {
        monthValue = String(year) + '-' + String(month)
        if (month !== 12) {
          nextMonthValue = String(year) + '-' + String(nextMonth)
        } else {
          nextMonthValue = String(year + 1) + '-0' + String(1)
        }
      }
      if (String(anotherMonth).length < 2) {
        anotherMonthValue = String(anotherYear) + '-0' + String(anotherMonth)
      } else {
        anotherMonthValue = String(anotherYear) + '-' + String(anotherMonth)
      }
      const material = monthValue + '-'
      const material2 = monthValue + '-0'
      const nextMaterial = nextMonthValue + '-'
      const nextMaterial2 = nextMonthValue + '-0'
      const anotherMaterial = anotherMonthValue + '-'
      const anotherMaterial2 = anotherMonthValue + '-0'
      for (let i = 1; i < currentFullDaysLength + 1; i++) {
        if (i < 10) {
          transDate = material2 + i
        } else {
          transDate = material + i
        }
        wholeDateArray.push(transDate)
      }
      for (let i = 1; i < nextFullDaysLength + 1; i++) {
        if (i < 10) {
          transDate = nextMaterial2 + i
        } else {
          transDate = nextMaterial + i
        }
        wholeDateArray.push(transDate)
      }
      console.log('기준배열', wholeDateArray)
      if (String(day).length < 2) {
        today = String(material2 + day)
      } else {
        today = String(material + day)
      }
      if (String(anotherDay).length < 2) {
        limitDay = String(anotherMaterial2 + anotherDay)
      } else {
        limitDay = String(anotherMaterial + anotherDay)
      }
      this.calendar.default.currentYear = year
      this.calendar.default.currentMonth = month
      this.calendar.default.currentDay = day
      this.calendar.default.limitDay = limitDay
      this.calendar.default.today = today
      // 현재시간 구하기
      this.getNearMedicalDate(today, wholeDateArray, 'current')
    },
    getNearMedicalDate (day, array, direction) {
      const medicalDateArray = JSON.parse(
        JSON.stringify(this.calendar.additional.medicalMonthDate)
      )
      const daySplitValue = day.split('-')
      let splitValue
      if (array !== null) {
        for (let i = 0; i < medicalDateArray.length; i++) {
          splitValue = medicalDateArray[i].split('-')
          if (array.includes(medicalDateArray[i])) {
            if (direction !== 'next') {
              if (daySplitValue[2] <= splitValue[2]) {
                this.removeA(array, medicalDateArray[i])
              }
            } else {
              if (daySplitValue[2] >= splitValue[2]) {
                this.removeA(array, medicalDateArray[i])
              }
            }
          }
        }
        this.calendar.default.totalDimm = array
      } else {
        const wholeDateArray = JSON.parse(
          JSON.stringify(this.calendar.default.totalDimm)
        )
        for (let i = 0; i < medicalDateArray.length; i++) {
          splitValue = medicalDateArray[i].split('-')
          if (wholeDateArray.includes(medicalDateArray[i])) {
            if (direction !== 'next') {
              if (daySplitValue[2] <= splitValue[2]) {
                this.removeA(wholeDateArray, medicalDateArray[i])
              }
            } else {
              if (daySplitValue[2] >= splitValue[2]) {
                this.removeA(wholeDateArray, medicalDateArray[i])
              }
            }
          }
        }
        this.calendar.default.totalDimm = wholeDateArray
      }
      const splitToday = day.split('-')
      const todayValue = splitToday[2]
      const nearMedicalDateArray = []
      let splitDate
      for (let i = 0; i < medicalDateArray.length; i++) {
        splitDate = medicalDateArray[i].split('-')
        if (
          !this.calendar.additional.nearStatus &&
          Number(todayValue) <= Number(splitDate[2])
        ) {
          nearMedicalDateArray.push(medicalDateArray[i])
        } else if (this.calendar.additional.nearStatus) {
          nearMedicalDateArray.push(medicalDateArray[i])
        }
      }
      this.calendar.additional.nearMedicalDate = nearMedicalDateArray
      if (nearMedicalDateArray.length < 1) {
        this.calendar.default.dateOne = day
        this.calendar.additional.stampWrapShowing = false
      } else {
        /*    if (this.calendar.additional.nearStatus) {
            this.reNewDimmed(nearMedicalDateArray)
          } */
        this.calendar.default.dateOne = this.calendar.additional.nearMedicalDate[0]
        this.calendar.additional.stampWrapShowing = true
      }
    },
    // 달력루프를 도는데 필요한 Date값을 설정
    getMonthInfo (val, direction) {
      console.log('기준이 되는 날', val)
      console.log('방향', direction)
      const currentMonth = Number(val[0].slice(5, 7))
      let nextMonth
      let previousMonth
      this.calendar.default.currentMonth = currentMonth
      this.calendar.default.currentYear = Number(val[0].slice(2, 4))
      if (currentMonth === 12) {
        nextMonth = 1
        previousMonth = currentMonth - 1
      } else if (currentMonth === 1) {
        previousMonth = 12
        nextMonth = currentMonth + 1
      } else {
        nextMonth = currentMonth + 1
        previousMonth = currentMonth - 1
      }
      this.calendar.default.nextMonth = nextMonth
      this.calendar.default.previousMonth = previousMonth
      const mutatedCurrentYear =
        '20' + String(this.calendar.default.currentYear)
      const newDate = new Date(
        Number(mutatedCurrentYear),
        this.calendar.default.currentMonth,
        0
      )
      const newArrival = String(newDate).split(' ')
      console.log('lastDayDate', newDate)
      console.log('lastDayInMonth', newArrival[2])
      let mutatedMonth
      if (currentMonth < 10) {
        mutatedMonth = '0' + currentMonth
      } else {
        mutatedMonth = currentMonth
      }
      const currentMaterial = this.calendar.default.limitDay.split('-')
      let dataVal
      if (direction === 'prev') {
        dataVal =
          mutatedCurrentYear +
          '-' +
          mutatedMonth +
          '-' +
          this.calendar.default.currentDay
      } else if (direction === 'next') {
        dataVal =
          mutatedCurrentYear + '-' + mutatedMonth + '-' + currentMaterial[2]
      }
      console.log('만든 val', dataVal)
      this.prevNextMaterial(
        mutatedCurrentYear,
        currentMonth,
        this.doctorCode,
        dataVal,
        direction
      )
    },
    async prevNextMaterial (year, month, doctorCode, val, direction) {
      await this.getMedicalDate(doctorCode, direction)
      this.getNearMedicalDate(val, null, direction)
    },
    // 현재 요일을 스트링으로 출력
    getDayInfo () {
      // 요일이름 구하기
      const week = []
      week.push('일', '월', '화', '수', '목', '금', '토')
      const day = new Date(this.calendar.default.dateOne)
      const dayName = day.getDay()
      const todayLabel = week[dayName]
      this.calendar.default.monthName = todayLabel
      // 상황판에 출력한 년월 요일 스트링
      const filterYear = this.calendar.default.dateOne.replace(/-/gi, '.')
      console.log('이거있니?', this.calendar.default.monthName)
      const month2 = this.calendar.default.monthName + '요일'
      const mutatedDate = filterYear + ' ' + month2
      this.notificationDate = mutatedDate
    },
    getAgoDayInfo () {
      // 요일이름 구하기
      const week = []
      week.push('일', '월', '화', '수', '목', '금', '토')
      console.log('데이셋 체크', this.GET_RESERVATION_ITEM_INFO.daySet)
      const day = new Date(this.GET_RESERVATION_ITEM_INFO.daySet)
      const dayName = day.getDay()
      const todayLabel = week[dayName]
      console.log('토토토토이', todayLabel)
      // 상황판에 출력한 년월 요일 스트링
      const filterYear = this.GET_RESERVATION_ITEM_INFO.daySet.replace(
        /-/gi,
        '.'
      )
      const month2 = todayLabel + '요일'
      const mutatedDate = filterYear + ' ' + month2
      this.notificationAgoDate = mutatedDate
    },
    // [부가적인 기능함수]
    // 테이블생성전 초기화함수
    initializeTable () {
      if (this.calendar.additional.stampWrapShowing) {
        // 예약 불가 처리된 화면 지우기
        for (let i = 0; i < this.timeTableMorning.length; i++) {
          if (
            document
              .querySelector('.stampItemMorning')
              .parentNode.childNodes[i].classList.contains('disabledItem')
          ) {
            document
              .querySelector('.stampItemMorning')
              .parentNode.childNodes[i].classList.remove('disabledItem')
          }
        }
        console.log('모닝 후')
        for (let i = 0; i < this.timeTableAfternoon.length; i++) {
          if (
            document
              .querySelector('.stampItemAfter')
              .parentNode.childNodes[i].classList.contains('disabledItem')
          ) {
            document
              .querySelector('.stampItemAfter')
              .parentNode.childNodes[i].classList.remove('disabledItem')
          }
        }
        console.log('애프터눈 후')
        // 예약선택했던 시간 지우기
        if (document.querySelector('.selected')) {
          document.querySelector('.selected').classList.remove('selected')
        }
        console.log('셀렉티드 후')
        // 예약시간 안내문구 삭제
        if (document.querySelector('.messaged')) {
          document
            .querySelectorAll('.word')
            .forEach(e => e.parentNode.removeChild(e))
          document.querySelector('.timeStamp').classList.remove('messaged')
        }
      }
      console.log('메시지드 후')
      this.reservationWord = ''
      this.timeTable = []
      this.timeTableMorning = []
      this.timeTableAfternoon = []
      this.reservationDate = ''
      this.reservationTime = ''
      this.officeHour = ''
      this.dataFlag = ''
    },
    // 예약시간이 없으면 코멘트를 출력함
    timeLess () {
      const para = document.createElement('p')
      para.innerText = '예약할 수 있는 시간이 없습니다.'
      para.classList.add('word')
      document.querySelector('.timeStamp').classList.add('messaged')
      document.querySelector('.timeStamp').appendChild(para)
    },
    // prev, next 버튼 클릭 시 화살표를 출력함
    setPreviosButton () {
      console.log('버튼생성기 진입')
      console.log(
        'this.calendar.default.dateOne',
        this.calendar.default.dateOne
      )
      console.log('this.calendar.default.today', this.calendar.default.today)
      const currentDaySplit = this.calendar.default.dateOne.split('-')
      const todaySplit = this.calendar.default.today.split('-')
      if (currentDaySplit[1] === todaySplit[1]) {
        document.querySelector(
          '.asd__change-month-button--previous'
        ).style.display = 'none'
        document.querySelector(
          '.asd__change-month-button--next'
        ).style.display = 'block'
      } else {
        document.querySelector(
          '.asd__change-month-button--previous'
        ).style.display = 'block'
        document.querySelector(
          '.asd__change-month-button--next'
        ).style.display = 'none'
      }
    },
    // Vuex 개체에 데이터셋 담기
    async carryData () {
      await this.tableBone()
      this.effectionOnDisabled()
    },
    async tableBone () {
      const timeArray = []
      const timeArrayMorning = []
      const timeArrayAfternoon = []
      const availableMorning = []
      const availableAfternoon = []
      console.log('테이블배열', this.GET_CALENDAR_LIST.medicalDate)
      for (let i = 0; i < this.GET_CALENDAR_LIST.medicalDate.length; i++) {
        // 현재시간보다 예약가능한 시간이
        const prepareDate = this.GET_CALENDAR_LIST.medicalDate[i].time.split(
          '~'
        )[0]
        const prepareDateFirst = prepareDate.split(':')[0]
        const prepareDateLast = prepareDate.split(':')[1]
        const dateTime = prepareDateFirst * 60 + Number(prepareDateLast)
        if (dateTime < 720) {
          timeArrayMorning.push(this.GET_CALENDAR_LIST.medicalDate[i].time)
          if (
            this.GET_CALENDAR_LIST.medicalDate[i].available === false ||
            (this.calendar.default.dateOne === this.calendar.default.today &&
              this.realTime >= dateTime)
          ) {
            availableMorning.push(String(i))
          }
        } else if (dateTime >= 720) {
          timeArrayAfternoon.push(this.GET_CALENDAR_LIST.medicalDate[i].time)
          if (
            this.GET_CALENDAR_LIST.medicalDate[i].available === false ||
            (this.calendar.default.dateOne === this.calendar.default.today &&
              this.realTime >= dateTime)
          ) {
            if (timeArrayMorning.length >= 1) {
              availableAfternoon.push(String(i - timeArrayMorning.length))
            }
          }
        }
        if (this.GET_CALENDAR_LIST.medicalDate[i].available !== false) {
          timeArray.push(this.GET_CALENDAR_LIST.medicalDate[i].time)
        }
        console.log('dateTiime', dateTime)
      }
      this.timeTable = timeArray
      this.timeTableMorning = timeArrayMorning
      this.timeTableAfternoon = timeArrayAfternoon
      this.inactivityIndexMorning = availableMorning
      this.inactivityIndexAfternoon = availableAfternoon
      this.ableTime = JSON.parse(JSON.stringify(timeArray))
      console.log('진료가능시간', this.ableTime)
      if (this.ableTime.length === 0) {
        if (document.querySelector('.messaged')) {
          document
            .querySelectorAll('.word')
            .forEach(e => e.parentNode.removeChild(e))
          document.querySelector('.timeStamp').classList.remove('messaged')
        }
        const para = document.createElement('p')
        if (this.calendar.default.dateOne === '') {
          para.innerText = '예약을 선택해주세요'
        } else {
          para.innerText = '예약할 수 있는 시간이 없습니다.'
        }
        para.classList.add('word')
        document.querySelector('.timeStamp').classList.add('messaged')
        document.querySelector('.timeStamp').appendChild(para)
      }
    },
    effectionOnDisabled () {
      console.log(
        'this.inactivityIndexMorning.length',
        this.inactivityIndexMorning.length
      )
      console.log(
        'this.inactivityIndexAfternoon.length',
        this.inactivityIndexAfternoon.length
      )
      for (let i = 0; i < this.inactivityIndexMorning.length; i++) {
        document
          .querySelector('.stampItemMorning')
          .parentNode.childNodes[this.inactivityIndexMorning[i]].classList.add(
            'disabledItem'
          )
      }
      for (let j = 0; j < this.inactivityIndexAfternoon.length; j++) {
        console.log(
          'this.inactivityIndexAfternoon[j]',
          this.inactivityIndexAfternoon[j]
        )
        console.log('랜덤', this.inactivityIndexAfternoon[0])
        console.log('j', j)
        document
          .querySelector('.stampItemAfter')
          .parentNode.childNodes[
            this.inactivityIndexAfternoon[j]
          ].classList.add('disabledItem')
      }
    },
    nextDone () {
      this.reservationSubmit()
    },
    async reservationSubmit () {
      // 12시 이전 문자열 1개 증가
      const neronero = this.reservationTime.split(':')
      const deleteMent = neronero[0].substring(0, neronero[0].indexOf('T'))
      const lengthCheck = neronero[0].replace(deleteMent, '')
      let firstDataSet
      if (lengthCheck.length === 2) {
        firstDataSet = neronero[0].replace('T', 'T0')
        const concatDataz =
          firstDataSet.trim() +
          ':' +
          neronero[1].trim() +
          ':' +
          neronero[2].trim()
        this.reservationTime = concatDataz
      }
      try {
        if (this.reservationTime === '' || this.reservatedTimeUnit === '') {
          this.SET_POPUP(true)
          this.popupSet.content = '예약시간을 선택해주세요.'
          this.popupSet.count = 'single'
          this.popupSet.confirmBtnText = '확인'
          return false
        }
        const requestData = {
          bookingCode: this.GET_RESERVATION_ITEM_INFO.bookingCode,
          requestContents: this.reservationWord,
          reservationDate: this.reservationTime,
          timeUnit: this.reservatedTimeUnit
        }
        await this.UPDATE_RESERVATION_LIST(requestData).then(() => {
          if (this.GET_RESERVATION_RESULT) {
            this.SET_POPUP(true)
            this.popupSet.content =
              '예약변경 신청이 완료되었습니다. <br/>담당직원과 통화 후에 예약이 확정됩니다.'
            this.popupSet.count = 'another'
            this.popupSet.nextLink = '/reservation/reservationConfirm'
            this.popupSet.closeType = 'action'
            this.popupSet.closeLink = '/reservation/reservationConfirm'
          } else {
            this.SET_POPUP(true)
            this.popupSet.content = '이미 완료된 예약입니다.'
            this.popupSet.count = 'another'
            this.popupSet.nextLink = '/reservation/reservationConfirm'
            this.popupSet.closeType = 'action'
            this.popupSet.closeLink = '/reservation/reservationConfirm'
          }
          console.log('예약 result: ', this.GET_RESERVATION_RESULT)
        })
      } catch (error) {
        console.log('error :', error)
        console.log('예약변경 api에서 에러발생')
        if (error.status !== 401) {
          if (
            error.data.response.message === 'reservation already completed.'
          ) {
            this.SET_POPUP(true)
            this.popupSet.content = '이미 완료된 예약입니다.'
            this.popupSet.count = 'another'
            this.popupSet.nextLink = '/reservation/reservationConfirm'
            this.popupSet.closeType = 'action'
            this.popupSet.closeLink = '/reservation/reservationConfirm'
          } else {
            this.SET_POPUP(true)
            this.popupSet.content = errorParser.parse(error)
          }
        } else {
          await this.$router.push('/login')
        }
      }
    },
    // 유틸클래스
    // 달력 디자인
    setCalendarVisual () {
      this.calendar.additional.width = window.innerWidth - 40
    },
    // 중복 배열제거
    removeDuplicatesArray (arr) {
      const tempArr = []
      for (let i = 0; i < arr.length; i++) {
        if (tempArr.length === 0) {
          tempArr.push(arr[i])
        } else {
          let duplicatesFlag = true
          for (let j = 0; j < tempArr.length; j++) {
            if (tempArr[j] === arr[i]) {
              duplicatesFlag = false
              break
            }
          }
          if (duplicatesFlag) {
            tempArr.push(arr[i])
          }
        }
      }
      console.log('ttf', tempArr)
      return tempArr
    },
    // 배열지우기
    removeA (arr) {
      let what
      const a = arguments
      let L = a.length
      let ax
      while (L > 1 && arr.length) {
        what = a[--L]
        while ((ax = arr.indexOf(what)) !== -1) {
          arr.splice(ax, 1)
        }
      }
      return arr
    }
  },
  beforeDestroy () {
    this.SET_POPUP(false)
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  }
}
</script>

<style lang="scss" scoped>
.timeStampWrap .timeStamp li.selected {
}
.timeStampWrap .timeStamp li.specialSelected {
  color: #fff;
  background: #ff6565;
}
</style>
